import { useContext } from "react";
import { UserContext } from "../contexts";


const useAuth = () => {
    return useContext(UserContext)
}

export default useAuth
